import { findFlagUrlByNationality } from "country-flags-svg";
import { environment } from '../../environments/environment';

export const getCountryFlag = (props: any, _id: string): string => {
    let current: any = {};
    props.redux?.account?.target?.['amazon'] && props.redux?.account?.target['amazon'].map((e: any) => {
        if (e._id == _id) current = e

    })
    const demonym = countryWithDemonym?.[current?.warehouses?.[0]?.['marketplace_id']] ?? [];
    return findFlagUrlByNationality(demonym['demonym'] ?? '') || demonym["svg"];
};

export const countryWithDemonym: {
    [name: string]: {
        "country": string;
        "demonym": String;
        "svg"?: any,
        "country_name": string
    }
} = {
    "A2Q3Y263D00KWC": {
        "country": "BR",
        "country_name": "Brazil",
        "demonym": "Brazilian"
    },
    "A2EUQ1WTGCTBG2": {
        "country": "CA",
        "country_name": "Canada",
        "demonym": "Canadian"
    },
    "A1AM78C64UM0Y8": {
        "country": "MX",
        "country_name": "Mexico",
        "demonym": "Mexican"
    },
    "ATVPDKIKX0DER": {
        "country": "US",
        "country_name": "United States",
        "demonym": "American"
    },
    "A2VIGQ35RCS4UG": {
        "country": "AE",
        "country_name": "United Arab Emirates",
        "demonym": "United Arab Emirates (U.A.E.)"
    },
    "A1PA6795UKMFR9": {
        "country": "DE",
        "country_name": "Germany",
        "demonym": "German"
    },
    "ARBP9OOSHTCHU": {
        "country": "EG",
        "country_name": "Egypt",
        "demonym": "Egyptian"
    },
    "A1RKKUPIHCS9HS": {
        "country": "ES",
        "country_name": "Spain",
        "demonym": "Spanish"
    },
    "A13V1IB3VIYZZH": {
        "country": "FR",
        "country_name": "France",
        "demonym": "French"
    },
    "AMEN7PMS3EDWL": {
        "country": "BE",
        "country_name": "Belgium",
        "demonym": "Belgian"
    },
    "A1F83G8C2ARO7P": {
        "country": "GB",
        "country_name": "United Kingdom",
        "demonym": "United Kingdom",
        "svg": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Flag_of_the_United_Kingdom_%281-2%29.svg/383px-Flag_of_the_United_Kingdom_%281-2%29.svg.png"
    },
    "A21TJRUUN4KGV": {
        "country": "IN",
        "country_name": "India",
        "demonym": "Indian"
    },
    "APJ6JRA9NG5V4": {
        "country": "IT",
        "country_name": "Italy",
        "demonym": "Italian"
    },
    "A1805IZSGTT6HS": {
        "country": "NL",
        "country_name": "Netherlands",
        "demonym": "Dutch"
    },
    "A1C3SOZRARQ6R3": {
        "country": "PL",
        "country_name": "Poland",
        "demonym": "Polish"
    },
    "A17E79C6D8DWNP": {
        "country": "SA",
        "country_name": "Saudi Arabia",
        "demonym": "Saudi Arabian"
    },
    "A2NODRKZP88ZB9": {
        "country": "SE",
        "country_name": "Sweden",
        "demonym": "Swedish"
    },
    "A33AVAJ2PDY3EV": {
        "country": "TR",
        "country_name": "Turkey",
        "demonym": "Turkish"
    },
    "A19VAU5U5O7RUS": {
        "country": "SG",
        "country_name": "Singapore",
        "demonym": "Singaporean"
    },
    "A39IBJ37TRP1C6": {
        "country": "AU",
        "country_name": "Australia",
        "demonym": "Australian"
    },
    "A1VC38T7YXB528": {
        "country": "JP",
        "country_name": "Japan",
        "demonym": "Japanese"
    },
    "AE08WJ6YKNBMC": {
        "country": "ZA",
        "country_name": "South Africa",
        "demonym": "South African"
    },
    "A28R8C7NBKEWEA": {
        "country": "IE",
        "country_name": "Ireland",
        "demonym": "Ireland",
        "svg": "https://upload.wikimedia.org/wikipedia/commons/4/45/Flag_of_Ireland.svg"
    }
};

export function changeLanguage(props: any, e: any, dispatcher: any) {
    props.di.globalState.set('language', e);
    props.history('loading');
    props.history(-1);
    dispatcher({
        type: 'update_language',
        state: {
            language: e,
        },
    });
}

export function hasSelectedLanguage(data: any, givenGroupCode: string, key: string) {
    // Check if data array exists and is an array
    if (Array.isArray(data?.data)) {
        // Loop through each item in data array
        for (let item of data?.data) {
            // Check if group_code is "language" and if selectedLanguage exists and is non-empty
            if (item?.group_code === givenGroupCode && item?.value && item?.value?.[key]) {
                return true;
            }
        }
    }
    return false;
}

export const saveConfigSourceOnly = async (groupCode: string, selectedLanguage: string, props: any) => {
    const url = `${environment.API_ENDPOINT}connector/config/saveConfig`;
    const requestHeaders = new Headers();
    const auth: any = props.di.globalState.getBearerToken();

    // Set headers
    requestHeaders.set('Authorization', auth);
    requestHeaders.set('appCode', "eyJzaG9waWZ5IjoiYW1hem9uX3NhbGVzX2NoYW5uZWwiLCJhbWF6b24iOiJhbWF6b24ifQ==");
    requestHeaders.set('appTag', "amazon_sales_channel");
    requestHeaders.set('Content-Security-Policy', "frame-ancestors https://admin.shopify.com");
    requestHeaders.set('Ced-Source-Id', props.di.globalState.get('source_id') ?? '');
    requestHeaders.set('Ced-Source-Name', "shopify");
    requestHeaders.set('Content-Type', 'application/json');

    const requestBody = JSON.stringify({
        data: [
            {
                data: {
                    selectedLanguage,
                },
                group_code: groupCode,
            },
        ],
    });

    try {
        const response = await fetch(url, {
            headers: requestHeaders,
            method: 'POST',
            body: requestBody,
        });
        const data = await response.json();

        // Return the response data back to the caller
        if (data?.success) {
            return { success: true, data };
        } else {
            return { success: false, message: data?.message || "Error saving configuration." };
        }
    } catch (error) {
        console.error("API Error:", error);
        return { success: false, message: "An error occurred while saving the configuration." };
    }
};

export const fetchLanguageDetails = async (props: any, t: any) => {
    const url = `${environment.API_ENDPOINT}connector/config/getConfig`;
    const requestHeaders: HeadersInit = new Headers();
    const auth: any = props.di.globalState.getBearerToken();

    // Set headers
    requestHeaders.set('Authorization', auth);
    requestHeaders.set('appCode', "eyJzaG9waWZ5IjoiYW1hem9uX3NhbGVzX2NoYW5uZWwiLCJhbWF6b24iOiJhbWF6b24ifQ==");
    requestHeaders.set('appTag', "amazon_sales_channel");
    requestHeaders.set('Content-Security-Policy', "frame-ancestors https://admin.shopify.com");
    requestHeaders.set('Ced-Source-Id', props.di.globalState.get('source_id') ?? '');
    requestHeaders.set('Ced-Source-Name', "shopify");
    requestHeaders.set('ced-target-name', "amazon");
    requestHeaders.set('Content-Type', 'application/json');

    // Define request body
    const requestBody = JSON.stringify({
        group_code: ["language"]
    });

    try {
        const response = await fetch(url, {
            headers: requestHeaders,
            method: 'POST',
            body: requestBody,
        });
        const data = await response.json();

        if (data?.success) {
            return data;
        } else {
            props.error(t("Failed to fetch language details."));
            return null;
        }
    } catch (error) {
        console.error("Error fetching language details:", error);
        props.error(t("An error occurred while fetching language settings."));
        return null;
    }
};